module.exports = __webpack_public_path__ + "img/vc.4ac5124f.svg";